import React from 'react' // УДАЛЕНО: { useEffect }
import Counting from '../components/CountingsComponents/Counting'
// УДАЛЕНО: import { useDispatch, useSelector } from 'react-redux'
// УДАЛЕНО: import { getCounting } from '../actions/MainActions'

function Usluqi({updateLocalStorage,counting}) {
    return (
        <main>
            <div className="container">
                <h2 className="section_header">Виды Расчетов</h2>
                <Counting updateLocalStorage={updateLocalStorage} counting={counting} />
            </div>
        </main>

    )
}

export default Usluqi